module.exports = __webpack_public_path__ + "img/bat.f8dcf3e8.svg";